import { Schema } from 'further-types/lp/account';

export const AccountSectionLabels = {
  [Schema.AccountSection.Assets]: 'Assets',
  [Schema.AccountSection.Expenses]: 'Expenses',
  [Schema.AccountSection.Income]: 'Income',
  [Schema.AccountSection.Payables]: 'Payables',
  [Schema.AccountSection.PartnersCapital]: "Partners' Capital",
};

export function parseAccountSection(
  value: string | undefined | null,
): Schema.AccountSection | undefined {
  if (!value) return undefined;
  const normalized = value.toLowerCase().trim();
  for (const [key, label] of Object.entries(AccountSectionLabels)) {
    if (label.toLowerCase() === normalized) {
      return key as Schema.AccountSection;
    }
  }
  return undefined;
}

export const BalanceSheetSectionLabels = {
  [Schema.BalanceSheetSection.InvestmentsAtCost]: 'Investments at cost',
  [Schema.BalanceSheetSection.UnrealisedGainLoss]:
    'Unrealised gain/loss on investments',
  [Schema.BalanceSheetSection.ReceivablesAndPrepayments]:
    'Receivables and prepayments',
  [Schema.BalanceSheetSection.AccruedIncome]: 'Accrued income',
  [Schema.BalanceSheetSection.CapitalDueFromPartners]:
    'Capital due from partners',
  [Schema.BalanceSheetSection.AccountsPayable]: 'Accounts payable',
  [Schema.BalanceSheetSection.AccruedExpenses]: 'Accrued expenses',
  [Schema.BalanceSheetSection.CapitalDueToPartners]: 'Capital due to partners',
};

export const BalanceSheetSectionsByAccountSection: Record<
  Schema.AccountSection,
  Array<Schema.BalanceSheetSection>
> = {
  [Schema.AccountSection.Assets]: [
    Schema.BalanceSheetSection.InvestmentsAtCost,
    Schema.BalanceSheetSection.UnrealisedGainLoss,
    Schema.BalanceSheetSection.ReceivablesAndPrepayments,
    Schema.BalanceSheetSection.AccruedIncome,
    Schema.BalanceSheetSection.CapitalDueFromPartners,
  ],
  [Schema.AccountSection.Payables]: [
    Schema.BalanceSheetSection.AccountsPayable,
    Schema.BalanceSheetSection.AccruedExpenses,
    Schema.BalanceSheetSection.CapitalDueToPartners,
  ],
  [Schema.AccountSection.PartnersCapital]: [],
  [Schema.AccountSection.Income]: [],
  [Schema.AccountSection.Expenses]: [],
};

export function parseBalanceSheetSection(
  value: string | undefined | null,
): Schema.BalanceSheetSection | undefined {
  if (!value) return undefined;
  const normalized = value.toLowerCase().trim();
  for (const [key, label] of Object.entries(BalanceSheetSectionLabels)) {
    if (label.toLowerCase() === normalized) {
      return key as Schema.BalanceSheetSection;
    }
  }
  return undefined;
}
